export default "__VITE_ASSET__DPjQAIg8__"